<template>
  <v-app class="d-block">
    <BaseAlert />

    <HeaderInstantQuotes />
    <NuxtPage />
    <Footer />
  </v-app>
</template>

<script>
export default {
  name: "InstantQuotesLayout",
};
</script>
